export const ADD_MODAL_TITLE = 'Новая задача';
export const EDIT_MODAL_TITLE = 'Редактировать задачу';
export const HISTORY_MODAL_TITLE = 'История изменений задачи';
export const TASK_PREVIEW_MODAL_TITLE = 'Просмотр задачи';
export const CHANGE_EMPLOYEE_TITLE = 'Сменить ответственного';
